import { useMemo } from 'react';

import { RoverBrand } from '@rover/types/src/RoverBrand';
import type { SeasonId } from '@rover/types/src/Season';

import ciafTheme from '../ciafTheme';
import madpawsTheme from '../madpawsTheme';
import roverTheme from '../roverTheme';
import { applySeason } from '../seasonalThemes';
import { ThemeWithBreakpoints } from '../themeConstants';

export type BrandThemeProviderProps = {
  brand?: RoverBrand;
  /** Seasonal overrides, applied to the Rover brand only. */
  season?: SeasonId | null;
  children: React.ReactNode;
};

export const useBrandThemeMemo = (
  brand: RoverBrand,
  season?: SeasonId | null
): ThemeWithBreakpoints => {
  return useMemo(() => {
    switch (brand) {
      case RoverBrand.CatInAFlat:
        return ciafTheme;
      case RoverBrand.MadPaws:
        return madpawsTheme;
      case RoverBrand.Rover:
      default:
        return applySeason(roverTheme, season);
    }
  }, [brand, season]);
};
